<template>
  <a-modal :title="title" v-model="visible" @ok="handleOk" class="preview-print-model">
    <div class="preview-print-box">
      <div class="add-preview add-preview-show" v-for="(item,index) in imgUrl" :key="index" :id="'print-img-'+index">
        <viewer :images="item">
          <img :src="item" class="table-img" style="width: 200px" />
        </viewer>
        <div class="look-delete">
          <a-icon type="eye" @click="btnLookImg(item,index)" />
          <a-icon type="edit" />
          <a-icon type="delete" />
          <viewer :images="item">
            <img :src="item" class="table-img" style="width: 20px" />
          </viewer>
        </div>
      </div>
      <div class="add-preview" @click="btnPrintPreview">
        <img src="@/assets/image/add@2x.png" alt="" class="image">
      </div>
    </div>
    <!-- <div class="print-page" v-for="(item,index) in 5" :key="index" :id="'imageWrapper'+index">
      <print-editor></print-editor>
    </div> -->
    <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel" class="look-print-image">
      <img alt="example" style="width: 100%" :src="previewImage" />
    </a-modal>
  </a-modal>
</template>
<script>
// import html2canvas from "html2canvas";
// import printEditor from "./printEditor.vue";
export default {
  // components: {
  //   printEditor,
  // },
  data() {
    return {
      title: "选择模板",
      visible: false,
      imgUrl: [],
      previewVisible: false,
      previewImage: ''
    };
  },
  mounted() {
    // let _that = this;
    // setTimeout(function () {
    //   for (let i = 0; i < 6; i++) {
    //     _that.toImage(i);
    //   }
    // }, 10);
  },
  methods: {
    // 生成图片
    // toImage(index) {
    //   html2canvas(document.getElementById("imageWrapper" + index)).then(
    //     (canvas) => {
    //       let dataURL = canvas.toDataURL("image/png");
    //       this.imgUrl.push(dataURL);
    //     }
    //   );
    // },
    btnLookImg(item,index) {
      this.previewImage = item;
      this.previewVisible = true;
    },
    handleCancel() {
      this.previewVisible = false;
    },
    open(data) {
      this.visible = true;
      console.log(data)
      this.imgUrl = data
    },
    cancel() {
      this.visible = false;
    },
    handleOk() {
      //   this.$emit('btnOk')
    },
    btnPrintPreview() {
      this.visible = false;
      this.$router.push({ path: "/printmanagement/printset/printPage" });
    },
  },
  watch: {
    visible() {
      // if (this.visible) {
      //   let _that = this;
      //   setTimeout(function () {
      //     for (let i = 0; i < 6; i++) {
      //       _that.toImage(i);
      //     }
      //   }, 10);
      // }
    },
  },
};
</script>

<style lang="scss">
.preview-print-model {
  width: 1000px !important;
  .ant-modal-footer {
    padding-bottom: 30px;
  }
  // .print-page {
  //   position: absolute;
  //   left: 0;
  //   bottom: 20000px;
  // }
}
.preview-print-box {
  display: flex;
  flex-wrap: wrap;
  .add-preview {
    width: 202px;
    height: 216px;
    border: 1px solid #e6e6e6;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 10px;
    position: relative;
    .look-delete {
      position: absolute;
      width: 100%;
      height: 100%;
      background-color: rgba(0,0,0,0);
      top: 0;
      left: 0;
      transition: 0.8s;
      display: flex;
      align-items: center;
      justify-content: center;
      .anticon {
        font-size: 28px;
        padding: 0 10px;
        color: rgba(255,255,255,0);
      }
    }
  }
  .add-preview-show:hover {
    .look-delete {
      background-color: rgba(0,0,0,0.4);
      .anticon {
        color: rgba(255,255,255,1);
      }
    }
  }
}
.look-print-image {
  width: 1000px !important;
}
</style>